import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from "lodash";
import {isResultsPanelOpen} from "../../../../store/reducers/results";
import {closeResultsPanel, openResultsPanel, resetResultsPanel} from "../../../../store/actions/results";
import CarbonMetre from './carbon-metre/CarbonMetre';
import EnergyOutput from './outputs/EnergyOutput';
import CarbonMetreHint from './carbon-metre/CarbonMetreHint';
import {getYearData} from '../../../../store/reducers/year';
import {IYear} from '../../../../data/data';
import {showModal} from '../../../../store/actions/modals';
import {MODALS} from '../../../../store/reducers/modal';

interface Props
{
    is_open: boolean;
    year: IYear;
    openResultsPanel: () => void;
    closeResultsPanel: () => void;
    resetResultsPanel: () => void;
    showYearInfo: () => void;
}

import './GameUi.scss';

class GameUi extends React.Component<Props, null>
{
    summary_el: HTMLElement;
    detail_el: HTMLElement;

    constructor(public props: Props)
    {
        super(props);
    }


    componentDidUpdate(prev_props: Props)
    {
        // console.log('props', prev_props, this.props);
    }


    togglePanel = () =>
    {
        const {is_open, openResultsPanel, closeResultsPanel} = this.props;

        is_open ? closeResultsPanel() : openResultsPanel();
    };


    getContainerBottom = () =>
    {
        const {is_open} = this.props;

        if (! this.summary_el || ! this.detail_el) return '0';

        if (is_open) return '10%';

        const {height:summary_height} = this.summary_el.getBoundingClientRect();
        const {height:detail_height} = this.detail_el.getBoundingClientRect();

        return detail_height * -1 + 'px';
    };


    showPanel = () =>
    {
        const {resetResultsPanel, closeResultsPanel} = this.props;

        resetResultsPanel();

        _.delay(closeResultsPanel, 1000);
    };

    // showPanel = _.debounce(() =>
    // {
    //     const {closeResultsPanel, is_open} = this.props;
    //
    //     console.log('on UI ref', is_open);
    //
    //     closeResultsPanel();
    // }, 1000);


    render()
    {
        const {is_open, year, showYearInfo} = this.props;

        return <React.Fragment>

            <div
                styleName={'background'}
                style={{ opacity: is_open ? 1 : 0 }}/>

            <div styleName={'game-ui'}>

                <div styleName={'scenario-reminder'} onClick={showYearInfo}>

                    <div styleName={'edf-logo'}><img src={'img/edf-logo.jpg'} /></div>
                    <div styleName={'reminder-text'}>{year.reminder}</div>

                </div>

                <div>

                    <CarbonMetre />

                </div>

                <div styleName={'second-row'}>

                    <EnergyOutput />

                    <CarbonMetreHint />

                </div>

            </div>


           {/* <div
                styleName={'game-ui'}
                style={{ bottom: this.detail_el ? this.getContainerBottom() : '-100%' }}
                ref={this.showPanel}>

                <ToggleButton
                    is_open={is_open}
                    togglePanel={this.togglePanel}/>

                <div
                    styleName={'energy-mix'}>

                    <EnergyMixPanel />

                </div>

                <
                    styleName={'summary'}
                    ref={el => this.summary_el = el}>

                    <OutputPanel />

                </div>

                <div
                    styleName={'detail'}
                    ref={el => this.detail_el = el}>

                    <div styleName={'text-details'}>

                        <p>How are you doing?</p>

                        <p>you should build more {this.props.hint[0]}</p>

                    </div>

                    <div styleName={'power-source-details'}>

                        <PowerSourceDetails />

                    </div>

                </div>

            </div>*/}

        </React.Fragment>
    }
}


const mapStateToProps = (state) =>
{
    return {
        is_open: isResultsPanelOpen(state),
        year: getYearData(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        openResultsPanel: () => dispatch(openResultsPanel()),
        closeResultsPanel: () => dispatch(closeResultsPanel()),
        resetResultsPanel: () => dispatch(resetResultsPanel()),
        showYearInfo: () => dispatch(showModal(MODALS.YEAR)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GameUi);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/game-ui/GameUi.tsx